import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=4b4b8213&"
import script from "./UserDetails.vue?vue&type=script&lang=js&"
export * from "./UserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b4b8213')) {
      api.createRecord('4b4b8213', component.options)
    } else {
      api.reload('4b4b8213', component.options)
    }
    module.hot.accept("./UserDetails.vue?vue&type=template&id=4b4b8213&", function () {
      api.rerender('4b4b8213', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Page/UserProfile/UserDetails.vue"
export default component.exports